interface Breadcrumb {
    source: number;
    page: {
        pk_id: number,
        name: string,
        alias: string,
        embed_url: string,
        route_url: string,
        is_pb_page: boolean,
        icon: string,
        is_visible: boolean
    };
    module: {
        pk_id: number,
        name: string,
        alias: string,
        is_visible: boolean
    };
    order: number;
    next_page: {
        pk_id: number,
        name: string,
        alias: string,
        embed_url: string,
        route_url: string,
        is_pb_page: boolean,
        icon: string,
        is_visible: boolean
    };
}
// OnNextClickHandler - the function that handles next button functionality in the simulator module pages
// below function takes in these parameters 
// module objects from dynamicBreadcrumbs redux state variable,  
// MODULE_TO_PAGE_MAPPING - the variable that indicates the current page that user is in
// currentScenarioId - the current scenario ID
// navigate - passing it as a prop for useNavigate hook
export default function OnNextClickHandler(
    dynamicBreadcrumbs: Breadcrumb[],
    MODULE_TO_PAGE_MAPPING: string,
    currentScenarioId: string,
    navigate: (path: string) => void
) {
    dynamicBreadcrumbs.forEach((breadcrumb) => {
        if (breadcrumb.module.name == MODULE_TO_PAGE_MAPPING) {
            const nextRoute = breadcrumb.next_page.route_url.replace(':id', currentScenarioId);
            if (nextRoute) {
                navigate(nextRoute);
            }
        }
    })
};
